import React, { useMemo } from 'react'

import List from './List'
import usePoints from './usePoints'

const WhyUseUs = ({ currentHost, margin }) => {
  const points = usePoints()

  const pointsItems = useMemo(() =>
          points,
      [currentHost]
  )
  return <List pointsArr={pointsItems} margin={margin} />
}

export default WhyUseUs
